module.exports = __webpack_public_path__ + "static/media/Defense.06aac1aa.svg";